import { keepPreviousData, useQuery } from '@tanstack/react-query';
import { ScenarioScope, scopeKey, useScenarioScope } from '../scope';
import { ScenarioSummary } from '../types';

export function useScenarios(includeArchived = false, scopeOverride?: ScenarioScope) {
  const contextScope = useScenarioScope();
  const scope = scopeOverride ?? contextScope;
  const { data, isLoading, isError } = useQuery<ScenarioSummary[]>({
    queryKey: [
      ...(scope ? scopeKey(scope) : ['clients', undefined, 'cashflow-scenarios']),
      { includeArchived: includeArchived || undefined },
    ],
    enabled: Boolean(scope),
    // Toggling "show archived" changes the key; keep the previous list on
    // screen instead of unmounting the section (and the switch) mid-click.
    placeholderData: keepPreviousData,
  });
  return { scenarios: data, isLoading, isError };
}
